import { render } from "./SamochodyPage.vue?vue&type=template&id=1c2fb292&scoped=true"
import script from "./SamochodyPage.vue?vue&type=script&lang=js"
export * from "./SamochodyPage.vue?vue&type=script&lang=js"

import "./SamochodyPage.vue?vue&type=style&index=0&id=1c2fb292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2fb292"]])

export default __exports__